import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export const STATUS_META = {
  inbox: { label: "Inbox", cls: "bg-stone-100 text-stone-600 dark:bg-stone-800 dark:text-stone-300" },
  pendiente: { label: "Pendiente", cls: "bg-amber-50 text-amber-700 dark:bg-amber-950/50 dark:text-amber-400" },
  importante: { label: "Importante", cls: "bg-teal-50 text-teal-700 dark:bg-teal-950/60 dark:text-teal-400" },
  aplicado: { label: "Aplicado", cls: "bg-green-50 text-green-700 dark:bg-green-950/50 dark:text-green-400" },
  archivado: { label: "Archivado", cls: "bg-stone-100 text-stone-400 dark:bg-stone-800/60 dark:text-stone-500" },
};

const base = "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium whitespace-nowrap";

export const StatusBadge = ({ status, className }) => {
  const meta = STATUS_META[status];
  if (!meta) return null;
  return <span className={cn(base, meta.cls, className)}>{meta.label}</span>;
};

export const AIBadge = ({ className }) => (
  <span className={cn(base, "bg-teal-50 text-teal-700 dark:bg-teal-950/60 dark:text-teal-400", className)}>
    ✦ IA
  </span>
);

export const AnalyzeBadge = ({ analyzeStatus, className }) => {
  if (analyzeStatus === "enriqueciendo")
    return (
      <span className={cn(base, "bg-amber-50 text-amber-700 dark:bg-amber-950/50 dark:text-amber-400", className)}>
        <Loader2 className="h-3 w-3 animate-spin" /> Enriqueciendo…
      </span>
    );
  if (analyzeStatus === "error")
    return (
      <span className={cn(base, "border border-amber-300/60 text-amber-700 dark:text-amber-400", className)}>
        Pendiente de enriquecer
      </span>
    );
  return <AIBadge className={className} />;
};
